// extracted by mini-css-extract-plugin
export var container = "styles-module--container--de0d1";
export var dot = "styles-module--dot--1a9fb";
export var flash = "styles-module--flash--3ceb6";